<template>
<div>

<v-dialog max-width="600" min-width="600" v-model="dialog.settings.visible" :fullscreen="$vuetify.breakpoint.xsOnly" transition="v-fade-transition" hide-details :hide-overlay="false" scrollable>
<v-card style="width:100%">

    <!-- <v-card-title style="flex-grow:0">
        <div class="white-dialog-title">
            Properties
        </div>
    </v-card-title>
    <v-divider/>  -->
    
    
   <v-card-text style="padding:5px;flex-grow:1;display:flex" :style="bodyStyle">

        <div style="flex-grow:1;overflow-y:scroll;height:100%">
            <v-expansion-panel v-model="expansionPanelNumber">
              <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Properties ({{dialog.field.name}})</div>
                </template>
                <v-card>
                    <v-card-text class="expansion-content">
                        <v-text-field v-model="dialog.field.name" hide-details single-line/>
                        <v-slider v-model="dialog.field.width" :label="sliderLabel('Width', dialog.field.width)" :step="10" color="primary" />
                    </v-card-text>
                </v-card>
                </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Filters</div>
                </template>
                <v-card>
                    <v-card-text class="expansion-content">
                        <v-slider v-model="field.width" :label="sliderLabel('Width', field.width)" :step="10" color="primary" />
                    </v-card-text>
                </v-card>
                </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Layout</div>
                </template>
                <v-card>
                    <v-card-text class="expansion-content">
                        <v-slider v-model="field.width" :label="sliderLabel('Width', field.width)" :step="10" color="primary" />
                    </v-card-text>
                </v-card>
                </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Filters</div>
                </template>
                <v-card>
                    <v-card-text class="expansion-content">
                        <v-slider v-model="field.width" :label="sliderLabel('Width', field.width)" :step="10" color="primary" />
                    </v-card-text>
                </v-card>
                </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Filters</div>
                </template>
                <v-card>
                    <v-card-text class="expansion-content">
                        <v-slider v-model="field.width" :label="sliderLabel('Width', field.width)" :step="10" color="primary" />
                    </v-card-text>
                </v-card>
                </v-expansion-panel-content>
              <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Filters</div>
                </template>
                <v-card>
                    <v-card-text class="expansion-content">
                        <v-slider v-model="field.width" :label="sliderLabel('Width', field.width)" :step="10" color="primary" />
                    </v-card-text>
                </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
        <div>
            <!-- sidebar -->
        </div>
   </v-card-text>

    <v-divider/> 
    <v-card-actions style="flex-grow:0">
       
            <v-spacer/>
            <v-btn text @click.native="cancel">{{dialog.settings.cancelLabel || 'Cancel'}}</v-btn>
            <v-btn text @click.native="save">{{dialog.settings.saveLabel || 'Save'}}</v-btn>                
   
    </v-card-actions>

    
</v-card> 
</v-dialog>

</div>
</template>

<script>
export default {

props:{
    settings: Object,
    //visible, cancelLabel, saveLabel, closeOnly

    dialog: Object,

    // saveOnEnter: Boolean,
    // disabled: {
    //     type: Boolean,
    //     default: false
    // },
    // field: Object,
},

components:{

},

data() {
    return {
        expansionPanelNumber:0,
        fieldBackup: {},
    }
},

computed: {

    field() {
        return this.dialog.field || {}
    },


    dialogVisible() {
        return this.dialog.settings.visible
    },

    dialogHeight() {
        if(this.$vuetify.breakpoint.xsOnly)
            return '100%'
        else {
            if(this.dialog.settings.height)
            return 
                this.dialog.settings.height
            return '500px'
        }
           
    },  
    
    bodyStyle() {
        return {
            'max-height': this.$vuetify.breakpoint.xsOnly ? '100%' : '400px'
        }
    }
},

methods: {
    sliderLabel(label, percent) {
        return label + (percent ? ' (' + percent + '%)' : ' (00%)')
    },

    save() {
        this.$emit('save')
        this.dialog.settings.visible = false
    },
    
    cancel() {
        this.$emit('cancel')
        this.dialog.settings.visible = false
    },

    enterPressed() {
        if(this.saveOnEnter)
            this.save()
    },

    show() {
        this.fieldBackup = {...this.dialog.field}

    }


},

watch: {
    'dialog.settings.visible' (visible) {
        if (visible) {
            this.show()
            this.$emit('show')
        } else
            this.$emit('hide')
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.white-dialog-title{
    font-size:16px;
    width:100%;
    /* text-align:center; */
    font-weight:500;
    
}
.expansion-content {
    background-color:#f8f8f8;
    padding-left:24px;
}
</style>


// WEBPACK FOOTER //
// PanelDialog.vue?55fe9e96